var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5C9 8.29565 9.31607 9.05871 9.87868 9.62132C10.4413 10.1839 11.2044 10.5 12 10.5C12.7956 10.5 13.5587 10.1839 14.1213 9.62132C14.6839 9.05871 15 8.29565 15 7.5C15 6.70435 14.6839 5.94129 14.1213 5.37868C13.5587 4.81607 12.7956 4.5 12 4.5C11.2044 4.5 10.4413 4.81607 9.87868 5.37868C9.31607 5.94129 9 6.70435 9 7.5Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.75C13.7902 0.75 15.5071 1.46116 16.773 2.72703C18.0388 3.9929 18.75 5.70979 18.75 7.5C18.75 10.751 13.618 18.027 12.304 19.837C12.269 19.8847 12.2232 19.9236 12.1704 19.9503C12.1176 19.9771 12.0592 19.991 12 19.991C11.9408 19.991 11.8824 19.9771 11.8296 19.9503C11.7768 19.9236 11.731 19.8847 11.696 19.837C10.382 18.027 5.25 10.751 5.25 7.5C5.25 5.70979 5.96116 3.9929 7.22703 2.72703C8.4929 1.46116 10.2098 0.75 12 0.75Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.979 17.7841C20.711 18.3251 22.5 19.2281 22.5 20.2501C22.5 21.9071 17.8 23.2501 12 23.2501C6.2 23.2501 1.5 21.9071 1.5 20.2501C1.5 19.2301 3.281 18.3291 6 17.7871",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.363c9426d2008eed38b8b4df78e1e5a1.svg";
export { ForwardRef as ReactComponent };